import { jsx as l } from "react/jsx-runtime";
const o = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80",
    ...c,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "#52F6BB",
        fillRule: "evenodd",
        d: "m50.48 61.467-32.248-.148c-2.077 0-4.7-2.369-4.7-4.463l-.44-33.1a2.07 2.07 0 0 0-2.056-2.073c-.546 0-1.07.211-1.448.613L.608 31.37c-.377.38-.608.91-.608 1.46v22.419c0 10.723 8.623 19.416 19.26 19.416h22.261c.546 0 1.07-.211 1.448-.613L51.949 65c.377-.38.608-.91.608-1.459 0-1.163-.923-2.094-2.056-2.094zM60.739 6.666h-22.26c-.547 0-1.07.212-1.449.614l-8.98 9.052c-.377.381-.608.91-.608 1.46 0 1.163.923 2.094 2.056 2.094l32.248.148c2.077 0 4.7 2.369 4.7 4.463l.44 33.1c0 1.143.923 2.073 2.056 2.073.546 0 1.07-.211 1.448-.613l9-9.074c.378-.38.61-.91.61-1.459v-22.42c0-10.723-8.624-19.416-19.261-19.416z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
